// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 167) return "static/chunks/167-69b25b82e8dbba9c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"589":"f2abd4699a48cf5b","903":"0230d42f83403d30"}[chunkId] + ".js";
};